import { selectIsSuperadmin } from '@/features/auth/authSlice';
import { useAppSelector } from '@/store/hooks';

/**
 * Hook personalizado para verificar si el usuario actual es superadmin
 * Usa los roles almacenados en el estado global (sin llamadas API adicionales)
 * @returns {boolean | null} - true si es superadmin, false si no lo es, null si está cargando
 */
export function useSuperadmin(): boolean | null {
  const { isLoading, isAuthenticated } = useAppSelector((state) => state.auth);
  const isSuperadmin = useAppSelector(selectIsSuperadmin);

  // Si aún está cargando la autenticación, retornar null
  if (isLoading) {
    return null;
  }

  // Si no está autenticado, retornar false
  if (!isAuthenticated) {
    return false;
  }

  return isSuperadmin;
}
